import { render, staticRenderFns } from "./BrandStateCategoryIcon.vue?vue&type=template&id=66050762&scoped=true&"
import script from "./BrandStateCategoryIcon.vue?vue&type=script&lang=ts&"
export * from "./BrandStateCategoryIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BrandStateCategoryIcon.vue?vue&type=style&index=0&id=66050762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66050762",
  null
  
)

export default component.exports